export const getMapsLibrary = () => typeof window !== 'undefined' && window.google && window.google.maps
    ? window.google.maps
    : null;
